// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c10d6492","977":"7f840f29"}[chunkId] + ".chunk.js";
};